<template>
  <br />
  <br />
  <br />
  <br />
  <br />
  <br />
  <v-card class="mx-auto" max-width="600">
    <v-toolbar color="red-darken-4">
      <v-img
        class="mx-auto"
        :width="20"
        cover
        src="/static/iconos/logo2.png"
      ></v-img>
      <v-toolbar-title align="center">Perfiles</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip location="bottom">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" @click="cerrarsesion" icon>
            <v-icon color="white">mdi-power-standby</v-icon>
          </v-btn>
        </template>
        <span>Cerrar sesión</span>
      </v-tooltip>
    </v-toolbar>
    <v-list>
      <v-list-item
        v-for="(item, i) in arrayperfil"
        :key="i"
        :value="item"
        active-color="red-darken-4"
        rounded="shaped"
        link
        @click="InfoPerfiles(item)"
      >
        <template v-slot:prepend>
          <v-avatar color="red-darken-4">
            <v-icon color="white">mdi-account-tie</v-icon>
          </v-avatar>
        </template>
        <v-list-item-title
          align="left"
          v-text="item.DescPerfil"
        ></v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import store from "@/store";
import { onMounted, ref, watch } from "vue";
import { useIdle } from "@vueuse/core";
var singout = false;
export default {
  data: () => ({
    arrayperfil: [],
    cerrar: false,
  }),
  methods: {
    // Info Perfiles
    InfoPerfiles(info) {
      this.$store.commit("infoperfil", info);
      this.$router.replace({ path: "/tci" });
    },
    // Si no activan la sesión se cierra el aplicativo
    cerrarsesion() {
      this.$router.replace({ path: "/" });
      localStorage.removeItem("infouser");
      localStorage.removeItem("registromenu");
      localStorage.removeItem("infoperfil");
      localStorage.removeItem("paginainfo");
      localStorage.removeItem("token");
      this.axios.defaults.baseURL = "";
      this.axios.defaults.headers.common["Authorization"] = "";
      this.axios.defaults.timeout = 0;
    },
    // Consulta si el usuario exista en el sistema
    PerfilesGet() {
      var userperfil = this.$store.getters.userperfil.userInfo;
      this.axios
        .get("/Perfiles/userperfil?Usuario=" + userperfil.Usuario_ID)
        .then((response) => {
          this.arrayperfil = response.data;
          localStorage.removeItem("registromenu");
          localStorage.removeItem("paginainfo");
        })
        .catch((e) => console.log(e));
    },    
  },
  watch: {
    // Si no activan la sesión se cierra el aplicativo
    cerrar(newQuestion, oldQuestion) {
      this.$swal({
        icon: "info",
        title: "Sesión Caducada",
        html: "Su sesión se ha cerrado por tiempo de inactividad. Vuelva a acceder",
      });
      singout = false;
      this.$router.replace({ path: "/" });
      localStorage.removeItem("infouser");
      localStorage.removeItem("registromenu");
      localStorage.removeItem("infoperfil");
      localStorage.removeItem("paginainfo");
      localStorage.removeItem("token");
      this.axios.defaults.baseURL = "";
      this.axios.defaults.headers.common["Authorization"] = "";
      this.axios.defaults.timeout = 0;
    },
  },
  created() {
    var interval = setInterval(() => {
      if (singout) {
        this.cerrar = singout;
        clearInterval(interval);
      }
    }, 100000);
  },
  setup() {
    const app_idle = ref(false);
    var TiempoInactividad =
      store.getters.userperfil.userInfo.TiempoSesionInactivaMilisegundos;
    const { idle, lastActive } = useIdle(TiempoInactividad); // Tiempo de la sesión
    onMounted(() => {
      watch(idle, (v) => {
        if (idle.value === true) {
          app_idle.value = true;
          singout = true;
        }
      });
    });
    return { app_idle };
  },
  mounted() {
    const infoToken = localStorage.getItem("token");
    if (infoToken) {
      this.axios.defaults.baseURL = this.$store.state.apiService;
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + infoToken;
      this.axios.defaults.timeout = 60000;
    }
    this.PerfilesGet();
  },
};
</script>
